import {isInt, isFloat} from '../utils/format';

const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;

export const required = () => input => {
	if (typeof input !== 'number' && typeof input !== 'boolean' && !input) {
		return 'Fältet får inte vara tomt.';
	}

	return true;
};

export const email = () => input => {
	const value = (input || '').trim();

	if (value.length === 0) {
		return true;
	}

	if (!emailPattern.test(value)) {
		return 'Ogilitlig E-Postadress';
	}

	return true;
};

export const max = n => input => {
	if (!isInt(input) || isFloat(input))
		return 'Kan enbart vara naturliga tal';

	if (input > n) {
		return `Får inte överstiga ${n}`;
	}

	return true;
};

export const min = n => input => {
	if (!isInt(input) || isFloat(input))
		return 'Kan enbart vara naturliga tal';

	if (input < n) {
		return `Måste vara större än ${n}`;
	}

	return true;
};

export const minLenght = n => input => {
	if (typeof input !== 'string' || input.length < n) {
		return `Krav på minst ${n} karaktärer.`;
	}

	return true;
};

export const maxLenght = n => input => {
	if (typeof input !== 'string' || input.length > n) {
		return `Får inte vara mer än ${n} karaktärer.`;
	}

	return true;
};

export const match = (value, name) => input => {
	if (input !== value) {
		return `Fält måste matcha ${name} fältet.`;
	}

	return true;
};


export const isBoolean = () => input => {
	if (typeof input !== 'boolean') {
		return 'Får endast vara sant eller falskt värde.';
	}

	return this;
};
